import { render } from "./TheChatSidebar.vue?vue&type=template&id=5506a64e"
import script from "./TheChatSidebar.vue?vue&type=script&lang=js"
export * from "./TheChatSidebar.vue?vue&type=script&lang=js"

import "./TheChatSidebar.vue?vue&type=style&index=0&id=5506a64e&lang=scss"

import exportComponent from "/var/www/production/releases/343/listings.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDrawer,QIcon,QBtn,QChip});
